export default __webpack_public_path__ + "static/media/tagihan-dibayar-overdue.fd81b018.svg";